/**
 * Pure function module for idle detection logic.
 * This can be tested without React, making tests more reliable.
 */

export interface IdleManagerCallbacks {
  onIdle: () => void;
  onActive: () => void;
}

export interface IdleManager {
  reset: () => void;
  cleanup: () => void;
  getLastActivity: () => number;
}

/**
 * Creates an idle manager that tracks user activity and triggers callbacks.
 * This is a pure function that can be tested without React.
 */
export function createIdleManager(
  idleTime: number,
  callbacks: IdleManagerCallbacks
): IdleManager {
  let timer: ReturnType<typeof setTimeout> | null = null;
  let lastActivity: number = Date.now();

  const reset = () => {
    lastActivity = Date.now();
    callbacks.onActive();

    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      callbacks.onIdle();
    }, idleTime);
  };

  const cleanup = () => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };

  const getLastActivity = () => lastActivity;

  // Initialize timer
  reset();

  return {
    reset,
    cleanup,
    getLastActivity,
  };
}
